const i = {
  skipAnimations: !1,
  useManualTiming: !1
};
export {
  i as MotionGlobalConfig
};
